const stateMaps = {
  // Estados globales
  TO_COLLECT: {
    progress: 0,
    color: "blue",
    name: "En preparación",
    description: "El vendedor está preparando tu pedido.",
    message:
      "El vendedor está preparando tu pedido. Te enviaremos un mail ni bien tengamos tu envío en nuestras manos y esté listo para ser despachado.",
    waiting: "Esperando preparación...",
    blocking: true,
    issues: {}
  },
  COLLECTED: {
    progress: 1,
    color: "blue",
    name: "En nuestras manos",
    description:
      "Retiramos tu pedido del domicilio del vendedor.",
    message:
      "Ya retiramos tu pedido del domicilio del vendedor, y está camino a nuestro centro de distribución. Te enviaremos un mail ni bien esté listo para ser despachado.",
    waiting: "Esperando despacho...",
    issues: {}
  },
  TO_RECOVER: {
    progress: 0,
    color: "blue",
    name: "A rescatar",
    description:
      "Recibimos la orden de retirar un paquete en tu domicilio.",
    message:
      "Retiraremos un paquete en tu domicilio. Te enviaremos un mail ni bien nuestro transportista esté en camino. Recordá tenerlo preparado, en su empaque original y tal cual lo recibiste.",
    waiting: "Esperando retiro...",
    issues: {}
  },
  RECOVERED: {
    progress: 1,
    color: "blue",
    name: "Rescatado",
    description:
      "Retiramos tu paquete en tu domicilio.",
    message:
      "Ya retiramos tu paquete en tu domicilio y está camino a nuestro centro de distribución, a la espera de ser retornado.",
    waiting: "Retornando...",
    issues: {}
  },
  TO_RECEIVE: {
    progress: 0,
    color: "blue",
    name: "A recibir",
    description:
      "Estamos aguardando que entregues tu devolución en el correo.",
    message:
      "Acercate a una sucursal del correo con el paquete que querés devolver. Recordá empaquetarlo y etiquetarlo correctamente con la etiqueta que te brindamos.",
    waiting: "Esperando paquete...",
    issues: {}
  },
  RECEIVED: {
    progress: 1,
    color: "blue",
    name: "Recibido",
    description:
      "El correo nos informó que ya entregaste tu devolución.",
    message:
      "Tu devolución ya fue recibida en el correo, y prontó será enviada a nuestro centro de distribución, para finalmente ser retornada al vendedor.",
    waiting: "Esperando retorno...",
    issues: {}
  },
  TO_DELIVER: {
    progress: 1,
    color: "blue",
    name: "Listo para despachar",
    description:
      "Recibimos tu pedido en nuestro centro de distribución.",
    message:
      "Tu pedido ya está en nuestro centro de distribución, listo para ser despachado. Te enviaremos un mail ni bien el repartidor esté camino a tu domicilio.",
    waiting: "Esperando despacho...",
    issues: {}
  },
  PICK_UP: {
    progress: 1,
    color: "blue",
    name: "En sucursal",
    description:
      "Entregamos tu pedido en el punto de retiro.",
    message:
      "Tu pedido ya está en el punto de retiro, listo para que lo retires. ¡No te duermas! tenés 5 días hábiles para retirarlo, desde la fecha de arribo.",
    waiting: "Esperando retiro...",
    issues: {}
  },
  DELIVERED: {
    progress: 3,
    color: "green",
    name: "¡Entregado!",
    description:
      "Entregamos tu pedido en tu domicilio.",
    message:
      "¡Listo! Esperamos hayas disfrutado la experiencia Jipink. Cualquier duda o sugerencia comunicate con nosotros. ¡Gracias!",
    issues: {}
  },
  TO_RETURN: {
    progress: 1,
    color: "blue",
    name: "A retornar",
    description:
      "Recibimos tu paquete en nuestro centro de distribución.",
    message:
      "Tu paquete ya está en nuestro centro de distribución, listo para ser retornado al vendedor.",
    waiting: "Esperando retorno...",
    issues: {}
  },
  RETURNED: {
    progress: 3,
    color: "green",
    name: "Retornado",
    description:
      "Retornamos tu paquete al domicilio del vendedor.",
    message:
      "Tu paquete ya está en manos del vendedor. Esperamos hayas disfrutado la experiencia Jipink. Cualquier duda o sugerencia comunicate con nosotros. ¡Gracias!",
    issues: {}
  },
  CANCELED: {
    progress: 3,
    color: "gray",
    name: "Cancelado",
    description: "Tu pedido fue cancelado.",
    message:
      "Tu pedido fue cancelado, por lo que no pasaremos por tu domicilio. Si pensás que fue cancelado por error, comunicate con nosotros. ¡Hasta la próxima!",
    issues: {}
  },
  BLOCKED: {
    progress: 1,
    color: "orange",
    name: "En Espera",
    description:
      "El vendedor está analizando tu caso para darle solución.",
    message:
      "El vendedor está validando tus datos y verificando tu pedido. Se estará comunicando con vos ante cualquier inconveniente detectado. ¡Gracias por tu paciencia!",
    waiting: "Esperando resolución...",
    blocking: true,
    issues: {}
  },
  ADMITTED: {
    progress: 1,
    color: "blue",
    name: "Recibido por el correo",
    description:
      "Tu pedido ya llegó al centro de distribución del correo.",
    message:
      "Tu pedido ya llegó al centro de distribución del correo. Te enviaremos un mail cuando estén en camino a tu domicilio.",
    waiting: "Esperando despacho...",
    issues: {}
  },
  CONFIRMED: {
    progress: 1,
    color: "blue",
    name: "¡Visita en camino!",
    description:
      "El repartidor está camino a tu domicilio.",
    message:
      "El repartidor ya está en camino y llegará en unos instantes. Asegurate que haya alguien mayor de 18 años para recibirlo.",
    waiting: "Esperando visita...",
    issues: {}
  },
  NOT_VISITED: {
    progress: 1,
    color: "orange",
    name: "No visitado",
    description:
      "El repartidor no pudo visitar el domicilio.",
    message:
      "El repartidor reportó un inconveniente y no pudo visitar el domicilio. Te estará contactando a la brevedad para poder coordinar la entrega.",
    waiting: "Esperando reintento...",
    issues: {}
  },
  ABORTED: {
    progress: 3,
    color: "gray",
    name: "Interrumpido",
    description:
      "Tu pedido está en proceso de cancelación.",
    message:
      "Tu pedido fue cancelado, por lo que no pasaremos por tu domicilio. Si pensás que fue cancelado por error, comunicate con nosotros. ¡Hasta la próxima!",
    issues: {}
  },
  EXPIRED: {
    progress: 3,
    color: "gray",
    name: "No retirado",
    description:
      "Tu pedido no fue retirado y está en proceso de retorno.",
    message:
      "Tu pedido no fue retirado a tiempo, por lo que retornará nuevamente al origen. ¡Hasta la próxima!",
    issues: {}
  },
  TO_APPROVE: {
    progress: 0,
    color: "blue",
    name: "A confirmar",
    description:
      "Tu operación aún no fue confirmada.",
    message:
      "Tu operación debe ser abonada por algunos de los medios de pago habilitados para poder continuar con la misma.",
    waiting: "Esperando pago...",
    issues: {}
  },
  UNSUPPORTED: {
    progress: 0,
    color: "red",
    name: "¡Ups!",
    description:
      "Error inesperado.",
    message:
      "Debido a un error de nuestro sistema no podemos reportar el estado de tu pedido en este momento. Por favor, intentá nuevamente en unos minutos",
    waiting: "Esperando novedades...",
    issues: {}
  },

  // Estados específicos por método EXPRESS
  EXPRESS: {
    DISPATCHED: {
      progress: 1,
      color: "blue",
      name: "Despachado",
      description:
        "Tu domicilio ya está en la ruta de un repartidor.",
      message:
        "Tu domicilio ya fue asignado a un repartidor y te estará visitando a la brevedad.",
      waiting: "Esperando visita...",
      issues: {}
    },
    VISITED: {
      progress: 1,
      color: "blue",
      name: "Visitado",
      description:
        "El repartidor visitó el domicilio.",
      message:
        "El repartidor visitó el domicilio pero no pudo concretar la operación. Si es la primera vez que lo intentamos, volveremos a pasar por tu domicilio dentro de las próximas 24 horas.",
      waiting: "Esperando reintento...",
      issues: {
        NOT_VISITED: {
          description:
            "El repartidor no pudo concretar la visita.",
          message:
            "Se registró un inconveniente durante la visita y se reprogramará el intento."
        }
      }
    }
  },
  // Estados específicos por método STANDARD
  STANDARD: {
    DISPATCHED: {
      progress: 1,
      color: "blue",
      name: "En manos del correo",
      description:
        "El correo ya tiene tu pedido y está camino a su centro de distribución.",
      message:
        "El correo ya tiene tu pedido y está camino a su centro de distribución, donde será clasificado y luego despachado a tu localidad.",
      waiting: "Esperando arribo a correo...",
      issues: {}
    },
    VISITED: {
      progress: 1,
      color: "blue",
      name: "Visitado",
      description:
        "El correo visitó tu domicilio.",
      message:
        "El correo nos informó que visitó el domicilio pero no pudo concretar la operación, por lo que tu pedido quedará a resguardo en la sucursal de Correo Argentino más cercana. Te enviaremos un mail ni bien nos informen que podés pasar a retirarlo por la sucursal.",
      waiting: "Esperando arribo a sucursal...",
      issues: {
        NOT_VISITED: {
          description:
            "El correo no pudo confirmar la visita.",
          message:
            "Se detectó un inconveniente en la visita y se actualizará el estado."
        }
      }
    }
  },
  // Estados específicos por método PICKUP
  PICKUP: {
    TO_RECOVER: {
      progress: 0,
      color: "blue",
      name: "A rescatar",
      description:
        "Recibimos la orden de retirar un paquete en el punto de retiro.",
      message:
        "Retiraremos un paquete en el punto de retiro. Te enviaremos un mail ni bien nuestro transportista esté en camino. Recordá tenerlo preparado, en su empaque original y tal cual lo recibiste.",
      waiting: "Esperando retiro...",
      issues: {}
    },
    RECOVERED: {
      progress: 1,
      color: "blue",
      name: "Rescatado",
      description:
        "Retiramos tu paquete en el punto de retiro.",
      message:
        "Ya retiramos tu paquete en el punto de retiro y está camino a nuestro centro de distribución, a la espera de ser retornado.",
      waiting: "Retornando...",
      issues: {}
    },
    TO_DELIVER: {
      progress: 1,
      color: "blue",
      name: "Listo para despachar",
      description:
        "Recibimos tu pedido en nuestro centro de distribución.",
      message:
        "Tu pedido ya está en nuestro centro de distribución, listo para ser despachado. Te enviaremos un mail ni bien el repartidor esté camino al punto de retiro.",
      waiting: "Esperando despacho...",
      issues: {}
    },
    DELIVERED: {
      progress: 3,
      color: "green",
      name: "¡Entregado!",
      description:
        "Entregamos tu pedido en el punto de retiro.",
      message:
        "¡Listo! Esperamos hayas disfrutado la experiencia Jipink. Cualquier duda o sugerencia comunicate con nosotros. ¡Gracias!",
      issues: {}
    },
    CANCELED: {
      progress: 3,
      color: "gray",
      name: "Cancelado",
      description:
        "Tu pedido fue cancelado.",
      message:
        "Tu pedido fue cancelado, por lo que no pasaremos por el punto de retiro. Si pensás que fue cancelado por error, comunicate con nosotros. ¡Hasta la próxima!",
      issues: {}
    },
    DISPATCHED: {
      progress: 1,
      color: "blue",
      name: "Despachado",
      description:
        "El punto de retiro ya está en la ruta de un repartidor.",
      message:
        "El punto de retiro ya fue asignado a un repartidor y te estará visitando a la brevedad.",
      waiting: "Esperando visita...",
      issues: {}
    },
    ADMITTED: {
      progress: 1,
      color: "blue",
      name: "Recibido por el correo",
      description:
        "Tu pedido ya llegó al centro de distribución del correo.",
      message:
        "Tu pedido ya llegó al centro de distribución del correo. Te enviaremos un mail cuando estén en camino a tu punto de retiro.",
      waiting: "Esperando despacho a destino...",
      issues: {}
    },
    CONFIRMED: {
      progress: 1,
      color: "blue",
      name: "¡Visita en camino!",
      description:
        "El repartidor está camino a tu punto de retiro.",
      message:
        "El repartidor ya está en camino y llegará en unos instantes. Asegurate que haya alguien mayor de 18 años para recibirlo.",
      waiting: "En camino...",
      issues: {}
    },
    VISITED: {
      progress: 1,
      color: "blue",
      name: "Visitado",
      description:
        "El repartidor visitó el punto de retiro.",
      message:
        "El repartidor visitó el punto de retiro pero no pudo concretar la operación. Si es la primera vez que lo intentamos, volveremos a pasar por el punto de retiro. De lo contrario, se comunicarán con vos para poder coordinar una nueva visita.",
      waiting: "Esperando reintento...",
      issues: {}
    },
    NOT_VISITED: {
      progress: 1,
      color: "orange",
      name: "No visitado",
      description:
        "El repartidor no pudo visitar el punto de retiro.",
      message:
        "El repartidor reportó un inconveniente y no pudo visitar el punto de retiro. Te estará contactando a la brevedad para poder coordinar la entrega.",
      waiting: "Esperando reintento...",
      issues: {}
    },
    ABORTED: {
      progress: 3,
      color: "gray",
      name: "Interrumpido",
      description:
        "Tu pedido está en proceso de cancelación.",
      message:
        "Tu pedido fue cancelado, por lo que no pasaremos, no hace falta que pases por tu punto de retiro. Si pensás que fue cancelado por error, comunicate con nosotros. ¡Hasta la próxima!",
      issues: {}
    },
  }
}

const issueMap = {
  // Issues globales
  BROKEN: {
    description: "Tu paquete está dañado y no puede ser entregado.",
    message:
      "Lamentablemente, el repartidor tuvo un problema con el paquete. Ya estamos en contacto con el vendedor para buscar una solución."
  },
  BUSINESS_HOURS: {
    description: "Tu domicilio tiene un horario limitado.",
    message:
      "Tu domicilio tiene un horario limitado y se encontraba cerrado a la hora de ser visitado por el repartidor."
  },
  CANCELED: {
    description: "Tu pedido fue cancelado, por lo que no volveremos a visitarte.",
    message:
      "La operación fue cancelada por el usuario o por el sistema, por lo que no se realizará la visita."
  },
  DUPLICATED: {
    description: "Tu domicilio ya fue visitado anteriormente.",
    message:
      "La operación fue marcada como duplicada, por lo que no se realizará la visita."
  },
  INCORRECT_ADDRESS: {
    description: "El repartidor no pudo encontrar la dirección proporcionada.",
    message:
      "El repartidor no pudo encontrar la dirección proporcionada. Te contactaremos para verificar los datos y coordinar una nueva entrega."
  },
  LOST: {
    description: "El repartidor reportó un problema con el paquete.",
    message:
      "Lamentablemente, el repartidor tuvo un problema con el paquete. Ya estamos en contacto con el vendedor para buscar una solución."
  },
  NOT_VISITED: {
    description: "El repartidor no pudo visitar el domicilio.",
    message:
      "El repartidor reportó un inconveniente y no pudo visitar el domicilio. Te estará contactando a la brevedad para poder coordinar la entrega."
  },
  ON_VACATIONS: {
    description: "El domicilio se encuentra cerrado por vacaciones.",
    message:
      "El domicilio reportado está cerrado por vacaciones. Se reprogramará la entrega una vez que el domicilio esté disponible."
  },
  OVERSIZE: {
    description: "El paquete es demasiado grande o pesado para ser transportado.",
    message:
      "El paquete excede las dimensiones o peso permitidos para el transporte. Nos pondremos en contacto para coordinar una solución."
  },
  REJECTED: {
    description: "Se rechazó la operación en tu domicilio.",
    message:
      "El repartidor visitó el domicilio, pero la operación fue rechazada o desconocida por la persona que lo recibió."
  },
  RESCHEDULED: {
    description: "Se reprogramó la visita para una nueva fecha.",
    message:
      "La entrega fue reprogramada para una nueva fecha. Te enviaremos un mail con los detalles de la nueva entrega."
  },
  STOLEN: {
    description: "El repartidor reportó un problema con el paquete.",
    message:
      "Lamentablemente, el repartidor tuvo un problema con el paquete. Ya estamos en contacto con el vendedor para buscar una solución."
  },
  UNREACHABLE_AREA: {
    description: "Tu domicilio está en una zona de difícil acceso.",
    message:
      "El domicilio se encuentra en una zona de difícil acceso, por lo que se reprogramará la entrega y se buscarán alternativas."
  },
  UNREACHABLE_RECEIVER: {
    description: "El repartidor intentó contactarse con vos sin éxito.",
    message:
      "El repartidor no pudo contactarse con vos a través del teléfono proporcionado, por lo que estaremos verificando tus datos."
  },
  VEHICLE_ISSUE: {
    description: "El repartidor tuvo un problema con su vehículo.",
    message: "El repartidor reportó un problema con su vehículo, por lo que se reprogramará la visita y te informaremos sobre la nueva fecha."
  },
  WRONG_PRODUCT: {
    description: "El producto transportado es incorrecto.",
    message: "El producto es incorrecto, por lo que coordinaremos la devolución y el envío del producto correcto."
  },
  EXHAUSTED: {
    description: "Se agotaron los intentos de visita disponibles.",
    message:
      "Se agotaron todos los intentos de visita, por lo que no volveremos a pasar por tu domicilio."
  },
  FLEX_OUTSIDE_COVERAGE: {
      description: "Tu domicilio se encuentra fuera de la zona de cobertura",
      message:
        "Tu pedido se encuentra fuera de nuestra zona de cobertura para entregas en el día. Te estaremos contactando a la brevedad para solucionarlo."
  },
  PICKUP_POINT_CLOSED: {
    description: "Punto de retiro cerrado.",
    message: "Punto de retiro cerrado."
  },
  PICKUP_POINT_UNKNOWN_SERVICE: {
    description: "Punto de retiro desconoce el servicio.",
    message: "Punto de retiro desconoce el servicio."
  },
  // Issues específicos por método PICKUP
  PICKUP: {
    DUPLICATED: {
      description: "El punto de retiro ya fue visitado anteriormente.",
      message:
        "La operación fue marcada como duplicada, por lo que no se realizará la visita."
    },
    NOT_VISITED: {
      description: "El repartidor no pudo visitar el punto de retiro.",
      message:
        "El repartidor reportó un inconveniente y no pudo visitar el punto de retiro. Te estará contactando a la brevedad para poder coordinar la entrega."
    },
    ON_VACATIONS: {
      description: "El punto de retiro se encuentra cerrado por vacaciones.",
      message:
        "El punto de retiro reportado está cerrado por vacaciones. Se reprogramará la entrega una vez que el punto de retiro esté disponible."
    },
    REJECTED: {
      description: "Se rechazó la operación en tu punto de retiro.",
      message:
        "El repartidor visitó el punto de retiro, pero la operación fue rechazada o desconocida por la persona que lo recibió."
    },
    UNREACHABLE_AREA: {
      description: "El punto de retiro está en una zona de difícil acceso.",
      message:
        "El punto de retiro se encuentra en una zona de difícil acceso, por lo que se reprogramará la entrega y se buscarán alternativas."
    },
    EXHAUSTED: {
      description: "Se agotaron los intentos de visita disponibles.",
      message:
        "Se agotaron todos los intentos de visita, por lo que no volveremos a pasar por el punto de retiro."
    }
  }
}

function applyIssueToState(baseState, issueCode) {
  if (!issueCode)
    return baseState

  let issueOverride = baseState.issues ? baseState.issues[issueCode] : null

  if (!issueOverride && issueMap[issueCode]) {
    issueOverride = issueMap[issueCode]
  }
  const result = issueOverride ? { ...baseState, ...issueOverride } : baseState

  return result
}

export default (method, data) => {
  const baseState =
    (method && stateMaps[method]?.[data.sub_status]) ||
    (method && stateMaps[method]?.[data.status]) ||
    stateMaps[data.sub_status] ||
    stateMaps[data.status] ||
    stateMaps.UNSUPPORTED

  const result = applyIssueToState(baseState, data.issue)

  return result
}